import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

interface Props {
  route: string
}

function Settings({ route }: Props) {
  return (
    <Box flexDirection="row" gap="s8" justifyContent="flexEnd">
      <Button.Router to={route} type="secondary" iconName="arrow-right" />
    </Box>
  )
}

export default observer(Settings)
